<agpr-take-over-panel
    [id]="id"
    header="Discover.dialogs.browsers.mediamarket.header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [responsiveWidth]="true"
    [minPanelWidth]="830"
    [maxPanelWidth]="1000"
    (closeTakeover)="closeDialog(null)"
>
    <div class="lhp">
        <h4 [id]="id + '_availableItems_heading'"> {{ 'Discover.dialogs.browsers.mediamarket.available' | localize }} </h4>
        <agpr-text-input
            [id]="id + '_quickFilter'"
            class="lhp-search"
            [(ngModel)]="filterString"
            (ngModelChange)="filterChange()"
            icon="fa-regular fa-duotone fa-magnifying-glass"
            ariaLabel="Common.dialog.dataSelect.filterPlaceholder"
            placeholder="Common.dialog.dataSelect.filterPlaceholder"
            [initialFocus]="true"
            [bottomMargin]="false"
        ></agpr-text-input>

        <agpr-scroll-panel #scrollPanel>
            <agpr-tree-list
                class="lhp-treelist"
                [items]="mediaMarketOptions"
                [(selection)]="selectedMediaMarkets"
                (selectionChange)="selectionChange()"
                [filterString]="filterString.length > 2 ? [filterString] : []"
            ></agpr-tree-list>

            @if (emptySubjects) {
                <agpr-message
                    [severity]="messageSeverityEnum.noContent"
                >
                    <span>
                        {{ 'Common.forms.treeList.noResultsMasculine' | localize: { type: 'Discover.dialogs.browsers.subject.header' } }}
                    </span>
                </agpr-message>
            }
        </agpr-scroll-panel>
    </div>
    <div class="rhp">
        <h4 [id]="id + '_selectedItems_heading'"> {{ 'Discover.dialogs.browsers.mediamarket.selected' | localize }} </h4>
        <agpr-scroll-panel>
            <ul class="rhp-groups">
                @for (chipGroup of chipGroups; track chipGroup; let i = $index) {
                    <li>
                        @if (chipGroup.chips.length > 0) {
                            <span class="rhp-chipGroup">
                                {{ chipGroup.heading | localize }}
                            </span>
                        }
                        <ul
                            [id]="'selectedGroup_' + i"
                            class="rhp-contents"
                            agprListKeyboardNavigation
                            listOrientation="horizontal"
                            [focusOnChild]="true"
                            [list]="chipGroup.chips"
                            role="group"
                            [attr.aria-label]="chipGroup.heading | localize"
                        >
                            @for (chip of chipGroup.chips; track chip; let j = $index) {
                                <li
                                    [id]="id + '_chip_' + j"
                                    class="agpr-chip"
                                >
                                    <span
                                        class="agpr-chip-label"
                                        [pTooltip]="chip.tooltip ? (chip.tooltip | localize) : (chip.label | localize)"
                                        tooltipPosition="top"
                                    >
                                        {{ chip.label | localize }}
                                    </span>
                                    <agpr-button
                                        [id]="id + '.chip_' + i + '.delete'"
                                        class="agpr-chip-button"
                                        [style]="buttonType.icon"
                                        icon="agpr-i-close"
                                        tooltip="Common.forms.chips.delete"
                                        tooltipPosition="top"
                                        [ariaLabel]="(chip.label | localize) + ' ' + ('Common.forms.chips.delete' | localize)"
                                        (click)="removeChip(chip)"
                                    ></agpr-button>
                                </li>
                            }

                        </ul>
                    </li>
                }
            </ul>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            (click)="closeDialog(null)"
            [style]="buttonType.secondary"
            label="cancel"
        ></agpr-button>
        <agpr-button
            (click)="resetAll()"
            [style]="buttonType.secondary"
            label="Discover.dialogs.browsers.subject.button.resetAll"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            (click)="apply()"
            [style]="buttonType.primary"
            label="Discover.dialogs.browsers.subject.button.applySelected"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
